import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {
    HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH,
    ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_EIGHT_ITEM_COUNT_WIDTH,
    ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_SEVEN_ITEM_COUNT_WIDTH,
} from "../../../../config/constants"

// Horizontal Filter Styling

interface HFStyledHeaderProps {
    breadcrumbsEnabled: boolean
    isMerchandisedUrl: boolean
}

export const HFStyledClearAllContainer = styled("div")`
    display: flex;
    flex-grow: 1;
    flex: 1 0 80%;
    padding-right: 1rem;
    padding-left: 1rem;
`

export const HFStyledClearAll = styled("div")`
    display: flex;
    flex-grow: 1;
    flex: 1 0 80%;
    justify-content: flex-end;
    padding-bottom: 1.5rem;
    max-width: ${({theme}) => theme.breakpoints.values.xl}px;
    margin: 0 auto;

    @media (max-width: ${breakpoints.values.md}px) {
        padding-right: 1rem;
        padding-left: 1rem;
    }

    @media (max-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }

    @media (max-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export const HFStyledHeader = styled("header")<HFStyledHeaderProps>`
    flex-grow: 1;
    flex: 1 0 80%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    position: sticky;
    top: calc(
        var(--next-header-lg-height, 6.5625rem)
            ${({breadcrumbsEnabled, isMerchandisedUrl}) =>
                breadcrumbsEnabled && isMerchandisedUrl ? " + var(--next-plp-breadcrumbs-height)" : ""}
    );
    z-index: 4;
    background-color: ${({theme}) => theme.colours.form.default.background};
    border-top: 0.0625rem solid ${({theme}) => theme.colours.palette.divider};
    border-bottom: 0.0625rem solid ${({theme}) => theme.colours.palette.divider};
    @media (min-width: ${breakpoints.values.md}px) {
        margin-left: 1rem;
        margin-right: 1rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export const StyledNavList = styled("div")`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(${HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH}% - 1px), 1fr));
    grid-gap: 0.5rem;
    box-sizing: border-box;
    @media (min-width: ${breakpoints.values.xl}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_EIGHT_ITEM_COUNT_WIDTH}% - 0.5rem), 1fr)
        );
    }
    @media (max-width: ${breakpoints.values.xl - 1}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_SEVEN_ITEM_COUNT_WIDTH}% - 0.5rem), 1fr)
        );
    }
    background-color: white;
`

export const StyledNavItem = styled("div")`
    border: ${({theme}) => theme.colours.form.input.border};
    border-radius: 0.25rem;
    box-sizing: border-box;
    padding: 0;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    text-transform: capitalize;
    :hover {
        border: ${({theme}) => theme.colours.utilities.activeBorder};
    }
`
export const StyledNavItemSecondRow = styled("div")`
    border: ${({theme}) => theme.colours.form.input.border};
    border-radius: 0.25rem;
    box-sizing: border-box;
    padding: 0;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    text-transform: capitalize;
    :hover {
        border: ${({theme}) => theme.colours.utilities.activeBorder};
    }
`

export const FeatNav = styled(StyledNavItem)`
    flex-grow: unset;
    border: none;
    :hover {
        border: none;
    }
`

export const StyledMoreLessItem = styled(StyledNavItem)`
    cursor: pointer;
    border-color: ${({theme}) => theme.colours.form.buttonSecondary.color};
`

export const MoreLessLabel = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({theme}) => theme.colours.form.buttonPrimary.background};
    font-weight: bold;
`

export const StyledNav = styled("nav")`
    padding: 0.5rem 0rem;
    border-right: none;
    border-left: none;
    margin: 0 auto;
    max-width: ${breakpoints.values.xxl}px;
`
type TotalRowProps = {
    totalRows: number
}

export const StyledNavListSecondRow = styled("div")<TotalRowProps>`
    display: grid;
    grid-template-columns: repeat(
        auto-fill,
        minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_EIGHT_ITEM_COUNT_WIDTH}% - 1px), 1fr)
    );
    @media (min-width: ${breakpoints.values.xl}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_EIGHT_ITEM_COUNT_WIDTH}% - 0.5rem), 1fr)
        );
    }
    @media (max-width: ${breakpoints.values.xl - 1}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_SEVEN_ITEM_COUNT_WIDTH}% - 0.5rem), 1fr)
        );
    }
    grid-gap: 0.5rem;
    margin-top: 0.5rem;
`
